export enum ErrorCode {
  UNKNOWN = 'UNKNOWN',
  NETWORK = 'NETWORK',
  GRAPHQL = 'GRAPHQL',
  VALIDATION = 'VALIDATION',
  AUTH = 'AUTH',
  NOT_FOUND = 'NOT_FOUND',
  PAYMENT = 'PAYMENT',
  FILE_UPLOAD = 'FILE_UPLOAD',
}
